"use client"

import type React from "react"
import { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs"
import PerformanceDashboardList from "./performance-dashboard-list"

const PerformanceDashboardContainer: React.FC = () => {
  const [refreshTrigger, setRefreshTrigger] = useState(false)

  const handleRefresh = () => {
    setRefreshTrigger((prev) => !prev)
  }

  return (
    <>
      <Breadcrumbs mainTitle="Performance Dashboard" parent="Performance Management" />
      <Container fluid>
        <Row>
          <Col md="12">
            <PerformanceDashboardList refreshTrigger={refreshTrigger} />
          </Col>
        </Row>
      </Container>
    </>
  )
}

export default PerformanceDashboardContainer
